import React from "react";
import FilePreviewMini from "./FilePreviewMini";
import BtnAddAnotherFile from "../../../../common/Buttons/BtnAddAnotherFIle";

const PreviewMiniFileSelected = ({ fileType, filesSelected, setFilesSelected, fileSelected, setFileSelected, setOpenMessageFileSize }) => {
    
    //Función para actualizar el archivo multimedia seleccionado, con su nombre.
    const handleFilePreviewSelected = (file) => setFileSelected(file.name);

    return (
        <div className="container-img__preview__mini">

            {/*---------Contenedor con las imagenes miniatura seleccionadas--------*/}
            <div className="container-img-preview__mini">

                {/*-------------Contenedor miniatura individual----------*/}
                {<FilePreviewMini typeFile={fileType} filesSelected={filesSelected}
                    handleFilePreviewSelected={handleFilePreviewSelected}
                    setFilesSelected={setFilesSelected} fileSelected={fileSelected} />}

                {/*----------Conenedor con el botón para agregar otra imagen---------------*/}
                <BtnAddAnotherFile filesSelected={filesSelected} setFilesSelected={setFilesSelected}
                    setFileSelected={setFileSelected} fileType={fileType} setOpenMessageFileSize={setOpenMessageFileSize}/>

            </div>
        </div>
    )
};

export default PreviewMiniFileSelected;